import React from "react";

export function StatusBadge({ status }: { status?: string }) {
  const colors: Record<string, string> = {
    "Reviewed": "bg-emerald-50 text-emerald-700 ring-emerald-200",
    "Pending": "bg-amber-50 text-amber-700 ring-amber-200",
    "In Progress": "bg-blue-50 text-blue-700 ring-blue-200",
    "Draft": "bg-slate-50 text-slate-700 ring-slate-200",
    "Submitted": "bg-violet-50 text-violet-700 ring-violet-200",
    "Completed": "bg-emerald-50 text-emerald-700 ring-emerald-200",
  };
  const cls = colors[status ?? ""] ?? "bg-slate-100 text-slate-700 ring-slate-200";
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}>
      {status ?? "—"}
    </span>
  );
}